








































import { Component } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import ShippingCompany from '@/api/shipping/index'
import distributorApi from '@/api/distributor/index.ts'

@Component({
  components: {}
})
export default class EditCompany extends AbpBase {
  form = {
    distributorName: null,
    identityNumber: null
  }

  ruleForm = {
    distributorName: [
      { required: true, message: '请输入分销员姓名', trigger: 'blur' }
    ],
    identityNumber: [{ required: true, message: '请输入身份证号', trigger: 'blur' }]
  }

  created() {
    this.getShippingCompany()
  }

  /**
   * 获取分销员信息
   */
  getShippingCompany() {
    let id = this.$route.query['id']
    if (id) {
      distributorApi.getDistributionInfo(id.toString()).then(res => {
        // console.log(res)
        this.form.identityNumber = res.data.idCard
        this.form.distributorName = res.data.name
      })
    }
  }

  submit() {
    let vm = this
    let form: any = vm.$refs.form
    // console.log(form);
    form.validate(valid => {
      if (valid) {
        let id = vm.$route.query['id'] ? vm.$route.query['id'].toString() : null
        distributorApi.updateDistributionInfo(id, form.model.identityNumber, form.model.distributorName).then(res => {
          vm.$router.push({
            name: 'distributorList'
          })
        })
      }
    })
  }
}
